import React from 'react';

import styles from '../styles/UnavailableSystem.module.css';

const UnavailableSystem = ({ dbStatus }) => {
  return (
    <span className={styles.lining}>
        <div className={styles.card}>
            <img className={styles.unLogo} src='/img/logo/mainlogo-gray-without-text-122.png' alt='Система «Поток»' />
            <a className={styles.bigText}>Система «Поток» в данный момент недоступна.</a>
            <a className={styles.explanation}>Попробуйте обновить страницу позже. Если вы используете VPN, рекомендуем отключить его. Статус: {dbStatus}</a>
        </div>
    </span>
  )
}

export default UnavailableSystem;